/**
 * Created by Neil Benn on 21.08.2018.
 */

define('common/js/lib/Serum.FontScale',['require', 'common/js/lib/util/getParameters'], function(require, getParameters){
  var params = getParameters(window.location);
  if (params['viewContext']){
    var nativeBridgeRequire = 'https://static.nrk.no/nativebridge/latest/nativebridge.min.js';
    var bridgeVersion = params['bridgeVersion'] || '';
    var versionMatch = /(\d+)\.\d+\.\d+$/.exec(bridgeVersion);
    if (versionMatch){
      require = requirejs.config({
        paths: {
          nativeBridge: [
            'https://static.nrk.no/nativebridge/major/' + versionMatch[1] + '/nativebridge.min',
            'https://static.nrk.no/nativebridge/latest/nativebridge.min'
          ]
        }
      });
      nativeBridgeRequire = 'nativeBridge';
    }

    require([nativeBridgeRequire], function(nativeBridge){
      function fontScaleHandler(data){
        if (data.fontScale && typeof data.fontScale === 'number'){
          var fontSize = Math.round(data.fontScale * 100) + '%';
          document.documentElement.style.fontSize = fontSize;
        }
      }
      function fontScaleErrorHandler(err){
        console.error('nativebridge error: ' + err);  // eslint-disable-line no-console
      }
      nativeBridge.rpc({
        topic: 'fontScale',
        data: {},
        resolve: fontScaleHandler,
        reject: fontScaleErrorHandler,
        timeout: 1000
      });

    });
  }
});

